import axios from 'axios';
import { useEffect, useRef, useState, } from 'react';
import { useNavigate } from "react-router-dom";
import { Accordion, AccordionContent, AccordionTitle, Button, Card, CardGroup, Checkbox, Confirm, Divider, Dropdown, Header, Icon, Image, Input, Modal, SemanticWIDTHSNUMBER, Table } from 'semantic-ui-react';
import '../../App.css'; // 애니메이션 스타일을 정의한 CSS 파일
import QrScanner from '../../components/QRscanner';
import serialExampleImage from './serial_image.png';
import "./style.css";

const apiEndpoint = process.env.REACT_APP_API_ENDPOINT;


interface Category {
  category: string;
  id: string;
  isActive: boolean;
}

interface Product {
  id: string;
  isActive: boolean;
  product: string;
  category: Category[];
}

interface optionDetail {
  id: number;
  option: string;
}

interface optionCategory {
  category: string;
  id: number;
  guide_text?: string;
  detail: optionDetail[]
}

interface optionsPair {
  category : optionCategory;
  detail : optionDetail;
}

interface DraxModelDetail {
  isSerial: boolean;
  serialNumber : string;
  serialImageUrl: string;
  remark?: string;
  options: number[];
  optionsPair: optionsPair[]
  warrantyDetail?: WarratyDetail;
}

interface WarratyDetail {
  is_warranty: boolean;
  shipment_date?: string;
  warranty_due_date?: string;
  wrranty_period_days?: number;
}

interface DraxModel {
  id: string;
  model: string;
  model_image: string;
  serial_location: string;
  isActive: boolean;
  product: string;
  product_name: string;
  product_obj: Product;
  modelDetail: DraxModelDetail[]
}

interface ProductOption {
  id: string;
  isActive: boolean;
  product: string;
  category: Category[];
}
interface DropdownOption {
  key: string;
  text: string;
  value: string;
}

function InputMachine() {
  const [selectedCategory, setSelectedCategory] = useState('');
  const [categoryOptions, setCategoryOptions] = useState([{'key':'-', 'text':'-', 'value':'-'}]);
  const [productOptions, setProductOptions] = useState<DropdownOption[]>([]);
  const [allProducts, setAllProducts] = useState<ProductOption[]>([]);
  const [selectedProduct, setSelectedProduct] = useState('');
  const [selectedProductName, setSelectedProductName] = useState('');
  const [models, setModels] = useState<DraxModel[]>([]);
  const [selectedModelsList, setSelectedModelsList] = useState<DraxModel[]>([]);
  const [selectedModel, setSelectedModel] = useState<DraxModel>();
  const [selectedCardIdList, setSelectedCardIdList] = useState<number[]>([]);
  const [selectedModelDiv, setSelectedModelDiv] = useState(false);

  const [open, setOpen] = useState(false); // confirm창 관련
  const [allDeleteOpen, setAllDeleteOpen] = useState(false); // confirm창 관련
  const [colNum, setColNum] = useState<SemanticWIDTHSNUMBER>(4);
  const [quantity, setQuantity] = useState('1');
  const fileInputRef = useRef<HTMLInputElement>(null);

  const [modelsList, setModelsList] = useState<DraxModel[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [serialSearchTerm, setSerialSearchTerm] = useState<string>('');

  const [openModal, setOpenModal] = useState(false);
  const [currentModel, setCurrentModel] = useState<DraxModel | null>(null);
  const [selectedDetails, setSelectedDetails] = useState(new Set());
  const [qrScanning, setQrScanning] = useState(false);
  const [isAccordionActive, setIsAccordionActive] = useState(true);

  // 창 사이즈에 따른 컬럼 개수 수정 코드
  useEffect(() => {
    if(sessionStorage.getItem('selectedModel')) {
      const savedModels = JSON.parse(sessionStorage.getItem('selectedModel') || '[]');
      setSelectedModelsList(savedModels);
    }

    sessionStorage.removeItem('product')
    sessionStorage.removeItem('productName')
    sessionStorage.removeItem('modelName')
    sessionStorage.removeItem('selectedCategory')

    const updateColNum = () => {
      const width = window.innerWidth;
      if (width > 600) {
        setColNum(4);
      } else if (width > 480) {
        setColNum(3);
      } else if (width > 350) {
        setColNum(2);
      } else {
        console.log(1)
        setColNum(1);
      }
    };

    window.addEventListener('resize', updateColNum);
    updateColNum(); // Initial call to set the correct class

    return () => {
      window.removeEventListener('resize', updateColNum);
    };

  }, []);

  // 백엔드에서 데이터 불러오기
  useEffect(() => {
    // 세션 저장소에 시작 시간이 없으면 현재 시간을 저장
    if (!sessionStorage.getItem('stepTwoStartTime')) {
      const startTime = new Date().toISOString();
      sessionStorage.setItem('stepTwoStartTime', startTime);
    }

    // models 정보 불러오기
    axios.get(`${apiEndpoint}/receiption/api/models/`)
      .then(response => {
        setModelsList(response.data);
      })
      .catch(error => {
        console.error('API 호출 중 오류 발생:', error);
      });

    // category정보 불러오기
    axios.get(`${apiEndpoint}/receiption/api/categories/`)
      .then(response => {
        // API 응답에서 제품 목록을 추출하여 DropdownProduct에 전달할 옵션으로 설정합니다.
        const categories = response.data.map((category: { [x: string]: any; }) =>(
            {'key':category.id, 'text':category.category, 'value':category.id}
          ))
        setCategoryOptions(categories);
      })
      .catch(error => {
        console.error('API 호출 중 오류 발생:', error);
      });

    // product 정보 불러오기
    axios.get(`${apiEndpoint}/receiption/api/products/`)
      .then(response => {
        setAllProducts(response.data);
      })
      .catch(error => {
        console.error('API 호출 중 오류 발생:', error);
      });
  }, []);

  // 카테고리가 변경될 때 제품과 검색어 초기화
  useEffect(() => {
    if (selectedCategory) {
      const filteredProducts = allProducts.filter(product =>
        // The category field on the product is an array, so we must check if the selectedCategory ID is in it.
        product.category.some(cat => cat.id === selectedCategory)
      );

      // Map the filtered list to Dropdown options
      const dropdownOptions: DropdownOption[] = filteredProducts
        .filter(product => product.isActive) // Filter only active products
        .map(product => ({
          key: String(product.id),
          text: product.product,
          value: String(product.id),
        }));

      setProductOptions(dropdownOptions);

      // Reset selected product and search term when category changes
      setSelectedProduct('');
      setSearchTerm('');
    } else {
      // If no category is selected, show no products or all products (depending on UX)
      setProductOptions([]);
    }
  }, [selectedCategory, allProducts]); // This effect depends on both selectedCategory and allProducts

  // 통합 필터링 로직
  useEffect(() => {
    let filtered = modelsList;

    // 1단계: 카테고리 필터링
    if (selectedCategory) {
      filtered = filtered.filter(model =>
        model.product_obj.category.some(cat => cat.id === selectedCategory)
      );
      console.log('After category filter:', filtered);
    }

    // 2단계: 제품 필터링 (카테고리가 선택된 경우에만)
    if (selectedCategory && selectedProduct) {
      filtered = filtered.filter(model => model.product === String(selectedProduct));
      console.log('After product filter:', filtered);
    }

    // 3단계: 검색어 필터링
    if (searchTerm.trim() !== '') {
      // 카테고리나 제품이 선택된 경우 해당 결과에서 검색
      // 아무것도 선택되지 않은 경우 전체에서 검색
      const baseData = (selectedCategory || selectedProduct) ? filtered : modelsList;

      filtered = baseData.filter(model =>
        model.model.toLowerCase().includes(searchTerm.toLowerCase()) ||
        model.product_name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      console.log('After search filter:', filtered);
    }

    setModels(modelsList);
    // 어떤 필터든 적용되면 결과를 보여줌
    if (selectedCategory || selectedProduct || searchTerm.trim() !== '') {
      setModels(filtered);
    }

    console.log('Final filtered results:', filtered);
  }, [selectedCategory, selectedProduct, searchTerm, modelsList]);


  useEffect(() => {
    if(selectedProduct && selectedProduct !== '-'){
      sessionStorage.setItem('product',selectedProduct)
      sessionStorage.setItem('productName',selectedProductName)
      sessionStorage.setItem('modelName','')

      setSelectedCardIdList([])
    }
  },[selectedCategory, selectedProduct, selectedProductName, searchTerm])

  const productDropdownOnclickHandler = (e:any, data:any) => {
    if (!selectedCategory){
      alert('카테고리 선택해주세요')
    }
  }

  const cardHandler = (DraxModel: DraxModel) => {
    const newModelDetail: DraxModelDetail = {
      isSerial: false,
      serialNumber: '',
      serialImageUrl: '',
      options:[],
      optionsPair: []

    };

    const updatedDraxModel: DraxModel = {
      ...DraxModel, // Copy all existing properties
      modelDetail: [
        ...(DraxModel.modelDetail || []), // Spread the existing modelDetail array or an empty array if it's null/undefined
        newModelDetail, // Add the new object
      ],
    };

    setSelectedModel(updatedDraxModel);
    setQuantity("1");
    setOpen(true);
  };

  const finishReceiptionHandler = (event: any, data: any) => {
    // Ensure selectedModel and quantity are valid
    if (!selectedModel || !quantity) {
      setOpen(false);
      return;
    }

    // Find the index of the existing model in the list
    const existingModelIndex = selectedModelsList.findIndex(item => item.id === selectedModel.id);

    let updatedSelectedModelsList = [...selectedModelsList];

    // 1. If the model already exists in the list
    if (existingModelIndex !== -1) {
      const existingModel = updatedSelectedModelsList[existingModelIndex];

      // Create a new model object with updated modelDetail
      const newModel = {
        ...existingModel,
        modelDetail: [
          ...(existingModel.modelDetail || []),
          // Add quantity number of new modelDetail objects
          ...Array.from({ length: parseInt(quantity) }, () => ({
            isSerial: false,
            serialNumber: '', // Assuming selectedModel has these properties
            serialImageUrl: '',
            options:[],
            optionsPair:[]
          })),
        ],
      };

      // Update the model in the list
      updatedSelectedModelsList[existingModelIndex] = newModel;

    } else {
      // 2. If it's a new model, create it with modelDetail
      const newModel = {
        ...selectedModel, // Spread existing properties
        modelDetail: [
          // Add quantity number of new modelDetail objects
          ...Array.from({ length: parseInt(quantity) }, () => ({
            isSerial: false,
            serialNumber: '', // Assuming selectedModel has these properties
            serialImageUrl: '',
            options:[],
            optionsPair:[]
          })),
        ],
      };

      // Push the new model to the list
      updatedSelectedModelsList.push(newModel);
    }

    // Update state and session storage
    setSelectedModelsList(updatedSelectedModelsList);
    sessionStorage.setItem('selectedModel', JSON.stringify(updatedSelectedModelsList));

    setSelectedCategory('')
    setSelectedProduct('')
    setSearchTerm('')

    setOpen(false);
  };

  const cancelReceiptHandler = (event:any, data:any) => {
    setOpen(false)
}

  const genConfirmModal = () => {
    return <>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        size='small'
        >
        <Modal.Header>[{selectedModel?.product_name}]{selectedModel?.model}</Modal.Header>
        <Modal.Content>
        <h5>
        접수할 수량을 입력해 주세요
        </h5>
        <div>
        <Input
          label='수량: '
          type='number'
          placeholder='수량을 입력하세요'
          value={quantity}
          onChange={(event, data) => setQuantity(event.target.value)}
          fluid
          size="small"
          min={1}
        />

        </div>

        </Modal.Content>

        <Modal.Actions>
        <Button onClick={cancelReceiptHandler}>
          취소
        </Button>
        <Button onClick={finishReceiptionHandler} color='orange'>
          확인
        </Button>
        </Modal.Actions>
      </Modal>
    </>
  }

  // JSX로 모델 데이터를 렌더링하는 함수
  const renderModels = (models:any) => {
      const activeModels = models.filter((model:any) => model.isActive)
      const modelsInCard = activeModels.map((model: any) => (
        <Card
          key={`card-${model.id}`}
          color={selectedCardIdList.includes(model.id) ? 'orange' : 'grey'}
          id={`card-${model.id}`}
          onClick={() => cardHandler(model)}
          style={{
            // border: selectedCardId === model.id ? '1px solid orange' : 'none',
            transform: selectedCardIdList.includes(model.id) ? 'scale(1.07)' : 'scale(1)',
            transition: 'transform 0.2s, border 0.2s',
          }}
          >
          {/* 아래 이미지에 모델 이미지들 db에 저장하고 그 이미지들을 랜더링 해주는 식으로 서비스 디벨롭 가능 */}
          <Image
          bordered
          src={`${model.model_image}`} // 배포할 때
          style={{
            width: '100%', // Make the image take full width of the card
            height: '150px', // Set a fixed height for the image
            // objectFit: 'cover', // Ensure the image covers the area without distortion, 이걸 적용하면 이미지가 클 때 잘리게 됨
          }}
          />
          <Card.Content>
            <Card.Header
            style={{
              height: '40px', // Set a fixed height for the header
              display: 'flex',
              alignItems: 'center', // Center the text vertically
              justifyContent: 'center', // Center the text horizontally
              fontSize: '1.1em', // Initial font size
              // overflow: 'hidden', // Hide overflowed text
              // textOverflow: 'ellipsis', // Add ellipsis for overflowed text
              // whiteSpace: 'nowrap', // Prevent text from wrapping
            }}>{model.model}</Card.Header>
          </Card.Content>
        </Card>
      ));
      return <div style={{ maxHeight: '600px', overflowY: 'auto' }}>
            <CardGroup itemsPerRow={colNum}>
                {modelsInCard}
            </CardGroup>
      </div>
  }

  const genSelectedModelString = () => {
    const handleModelClick = (model: DraxModel) => {
      // This function will handle opening the modal as you've set up
      // ... your existing modal logic
      setCurrentModel(model);
      setOpenModal(true);
    };

    return (
      <>

        <ul style={{ listStyle: 'none', padding: '0', margin: '0' }}>
          {selectedModelsList.map((data, index) => (
            <li
              key={index}
              onClick={() => handleModelClick(data)}
              style={{
                padding: '7px 15px',
                margin: '5px 15px',
                borderRadius: '5px',
                backgroundColor: 'rgb(255 247 234)', // Very light orange background
                border: '1px solid rgb(255, 208, 138)', // A shade of orange for the border
                cursor: 'pointer',
                transition: 'background-color 0.2s, transform 0.2s',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = '#FFE0B2'; // A slightly darker orange on hover
                e.currentTarget.style.transform = 'translateY(-2px)'; // Subtle lift effect
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = '#FFF3E0'; // Return to default
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <span style={{ fontWeight: 'bold', fontSize: 'medium'}}>
                - [{data.product_name}] {data.model}
              </span>
              <span style={{ color: '#E65100', fontWeight: 'bold' , fontSize: 'medium'}}>
                {data.modelDetail.length}
              </span>
            </li>
          ))}
        </ul>
      </>
    );
  };


  const navigate = useNavigate();

  // 2026-09-21: 고객정보(세션) 없이 이 화면에 들어오면(웹뷰 재시작·중간 화면 직접 진입) 빈 접수가 되므로 고객정보 화면으로 되돌림
  useEffect(() => {
    if (!sessionStorage.getItem('owner') || !sessionStorage.getItem('phone')) {
      alert('고객정보가 없습니다. 고객정보 입력 화면부터 다시 진행해 주세요.');
      navigate('/customer');
    }
  }, [navigate]);


  const handleNextButtonClick = () => {


    // 여기에 입력값 유효성 검사 등 다음으로 넘어갈 조건을 체크하는 로직을 추가할 수 있ㄴ습니다.
    const selectedModel = sessionStorage.getItem('selectedModel')
    if (selectedModel) {
      if (selectedModel.length !== 2) { // 선택했다가 해제했을 떄 '[]'로 session.stroage에 남게 되고 이 length는 2 이다.
        navigate('/reservation/')
        // toast.success('성공!')
      } else {
        alert("모델을 선택해주세요.");
      }
    } else {
      // toast.error("모델을 선택해주세요."); // toast가 적용 안됨.. 왜?
      alert("모델을 선택해주세요.");
    }

    sessionStorage.removeItem('isSerialNumberDisabled')
    sessionStorage.removeItem('serialNumber')

  };

  const handlePrevButtonClick = () => {
    navigate('/customer')
  };

  const processSerialData = async (serialNumber: string) => {
    console.log(serialNumber)

    // 2. Client-side duplicate check
    for (const model of selectedModelsList) {
        if (model.modelDetail.some(detail => detail.serialNumber === serialNumber)) {
            alert('이미 추가된 시리얼 번호입니다.');
            return; // Exit the function immediately
        }
    }

    // 3. If no duplicates are found, proceed with the backend request
    try {
        const response = await axios.get(
            `${apiEndpoint}/receiption/api/serialOCR/${serialNumber}`
        );

        console.log("server response: ", response.data);

        const webModelData: DraxModel = response.data.data.classification.web_model_data;
        const warrantyData: WarratyDetail = response.data.warranty_info;
        const newModelDetail: DraxModelDetail = {
            isSerial: true,
            serialNumber: response.data.extracted_serial_number || '', // Assuming backend returns the serial number
            serialImageUrl: response.data.uploaded_url || '',
            options: response.data.data.classification.web_model_data.options as number[],
            optionsPair: response.data.data.options_selection,
            warrantyDetail: warrantyData
        };


        let updatedSelectedModelsList = [...selectedModelsList];
        const existingModelIndex = updatedSelectedModelsList.findIndex(
            (item) => item.id === webModelData.id
        );

        if (existingModelIndex !== -1) {
            const existingModel = updatedSelectedModelsList[existingModelIndex];
            const updatedModel = {
                ...existingModel,
                modelDetail: [
                    ...(existingModel.modelDetail || []),
                    newModelDetail,
                ],
            };
            updatedSelectedModelsList[existingModelIndex] = updatedModel;
        } else {
            const newModel = {
                ...webModelData,
                modelDetail: [newModelDetail],
            };
            updatedSelectedModelsList.push(newModel);
        }

        setSelectedModelsList(updatedSelectedModelsList);

        sessionStorage.setItem('selectedModel', JSON.stringify(updatedSelectedModelsList));
        setSelectedModelDiv(true);
        alert('저장 성공')
        setTimeout(() => {setSelectedModelDiv(false);}, 500)

    } catch (error) {
        console.error("시리얼 번호 조회 중 오류 발생:", error);
        // Handle API errors
        alert('조회에 실패했습니다. 다시 시도해주세요.');
    }
  };

  const handleQrScanClick = () => {
    // Simply turn on the scanner
    setQrScanning(!qrScanning);
  };

  const handleScanSuccess = (decodedText: string) => {
    // After a successful scan, turn off the scanner
    setQrScanning(false);
    // Then process the data
    processSerialData(decodedText);
  };

  const handleScanError = (errorMessage: string) => {
    // This is the key change: ignore the `NotFoundException` error
    if (errorMessage.includes("No MultiFormat Readers were able to detect the code")) {
      // Do nothing, just pass. The scanner will remain active.
    } else {
      console.error("QR Scan Error:", errorMessage);
      // alert('QR 코드 인식에 실패했습니다. 다시 시도해주세요.');
      // setQrScanning(false);
    }
  };

  const handleSerialNumberUploadClick = () => {
    // This triggers the hidden file input
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    // Check if a file was selected
    if (event.target.files && event.target.files.length > 0) {
      const selectedFile = event.target.files[0];

      const formData = new FormData();
      formData.append('receiptName', 'Your_Receipt_Name_Here');
      formData.append('file', selectedFile);

      try {
        const response = await axios.post(
          `${apiEndpoint}/receiption/api/serialOCR/`,
          formData,
          {
            headers: { 'Content-Type': 'multipart/form-data' },
          }
        );

        //시리얼번호가 인식 되지 않은 경우 사용자에게 알림창 띄우기
        if (!response.data.extracted_serial_number) {
          alert('시리얼 번호를 인식하지 못했습니다. 시리얼번호가 잘 보이도록 다시 찍어주시거나 QR,직접입력,모델검색 등 다른 방법을 이용해주세요.');
          return; // Exit the function if no serial number was extracted
        }

        const webModelData: DraxModel = response.data.data.classification.web_model_data;
        const warrantyData: WarratyDetail = response.data.warranty_info;
        const newModelDetail: DraxModelDetail = {
          isSerial: true,
          serialNumber: response.data.extracted_serial_number || '',
          serialImageUrl: response.data.uploaded_url || '',
          options: response.data.data.classification.web_model_data.options as number[],
          optionsPair: response.data.data.options_selection,
          warrantyDetail: warrantyData
        };
        // 1. Check if the model already exists in the selectedModelsList
        const existingModelIndex = selectedModelsList.findIndex(
          (item) => item.id === webModelData.id
        );

        // 1.1 check if the serial number already exists
        for (const model of selectedModelsList) {
          if (model.modelDetail.some(detail => detail.serialNumber === newModelDetail.serialNumber)) {
              alert('이미 추가된 시리얼 번호입니다.');
              return; // Exit the function immediately
          }
        }

        // 2. Create a new list for immutability
        let updatedSelectedModelsList = [...selectedModelsList];

        if (existingModelIndex !== -1) {
          // 3. Model exists: Create an updated model object and replace it in the list
          const existingModel = updatedSelectedModelsList[existingModelIndex];
          const updatedModel = {
            ...existingModel,
            modelDetail: [
              ...(existingModel.modelDetail || []),
              newModelDetail,
            ],
          };
          updatedSelectedModelsList[existingModelIndex] = updatedModel;
        } else {
          // 4. Model does not exist: Create a new model with the detail and add it
          const newModel = {
            ...webModelData,
            modelDetail: [newModelDetail],
          };
          updatedSelectedModelsList.push(newModel);
        }

        // 5. Update the state with the new list
        setSelectedModelsList(updatedSelectedModelsList);
        sessionStorage.setItem('selectedModel', JSON.stringify(updatedSelectedModelsList));
        setSelectedModelDiv(true);
        alert('저장 성공')
        setTimeout(() => {setSelectedModelDiv(false);}, 500)

        // 기존에 선택된 파일 정보를 초기화
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
      } catch (error) {
        console.error('File upload failed:', error);
      }
    }
  };

  const handleSearchClick = async () => {
    // 1. Client-side validation: Check if a serial number was entered
    if (!serialSearchTerm) {
      alert("시리얼 번호를 입력해주세요.");
      return;
    }

    // 2. Client-side duplicate check
    // Loop through the selected models to find a duplicate serial number
    for (const model of selectedModelsList) {
        if (model.modelDetail.some(detail => detail.serialNumber === serialSearchTerm.trim().toUpperCase())) {
            alert('이미 추가된 시리얼 번호입니다.');
            return; // Exit the function immediately
        }
    }

    // 3. If no duplicates are found, proceed with the backend request
    try {
        const response = await axios.get(
            `${apiEndpoint}/receiption/api/serialOCR/${serialSearchTerm}`
        );

        console.log("server response: ", response.data);

        const webModelData: DraxModel = response.data.data.classification.web_model_data;
        const warrantyData: WarratyDetail = response.data.warranty_info;
        const newModelDetail: DraxModelDetail = {
            isSerial: true,
            serialNumber: response.data.extracted_serial_number || '', // Assuming backend returns the serial number
            serialImageUrl: response.data.uploaded_url || '',
            options: response.data.data.classification.web_model_data.options as number[],
            optionsPair: response.data.data.options_selection,
            warrantyDetail: warrantyData
          };

        let updatedSelectedModelsList = [...selectedModelsList];
        const existingModelIndex = updatedSelectedModelsList.findIndex(
            (item) => item.id === webModelData.id
        );

        if (existingModelIndex !== -1) {
            const existingModel = updatedSelectedModelsList[existingModelIndex];
            const updatedModel = {
                ...existingModel,
                modelDetail: [
                    ...(existingModel.modelDetail || []),
                    newModelDetail,
                ],
            };
            updatedSelectedModelsList[existingModelIndex] = updatedModel;
        } else {
            const newModel = {
                ...webModelData,
                modelDetail: [newModelDetail],
            };
            updatedSelectedModelsList.push(newModel);
        }

        setSelectedModelsList(updatedSelectedModelsList);
        sessionStorage.setItem('selectedModel', JSON.stringify(updatedSelectedModelsList));
        setSearchTerm('');

        setSelectedModelDiv(true);
        alert('저장 성공')
        setTimeout(() => {setSelectedModelDiv(false);}, 500)

    } catch (error) {
        console.error("시리얼 번호 조회 중 오류 발생:", error);
        // Handle API errors
        alert('조회에 실패했습니다. 다시 시도해주세요.');
    }
  };

  const handleDeleteDetails = () => {
    if (!currentModel) return;

    // Filter out the selected details
    const newModelDetails = currentModel.modelDetail.filter(
        (detail) => !selectedDetails.has(detail)
    );

    let updatedSelectedModelsList;
    if (newModelDetails.length === 0) {
        // If the array is empty, remove the entire model from the list.
        updatedSelectedModelsList = selectedModelsList.filter(
            (model) => model.id !== currentModel.id
        );
    } else {
        // Otherwise, update the existing model in the list.
        const updatedModel = {
            ...currentModel,
            modelDetail: newModelDetails,
        };
        updatedSelectedModelsList = selectedModelsList.map((model) =>
            model.id === currentModel.id ? updatedModel : model
        );
    }

    // Update the main state and session storage.
    setSelectedModelsList(updatedSelectedModelsList);
    sessionStorage.setItem('selectedModel', JSON.stringify(updatedSelectedModelsList));

    // Close the modal and reset state.
    setOpenModal(false);
    setSelectedDetails(new Set()); // Reset the Set
    setCurrentModel(null);


  };

  return (
    <>
      <div className="card">
        <Accordion>
          <AccordionTitle active={isAccordionActive} onClick={(e) => {setIsAccordionActive(!isAccordionActive)}} style={{ cursor: 'pointer' }}>
            <h3 className="mt-1 mb-1 align-center">
            <Icon name='dropdown' />시리얼번호로 모델정보 찾기
            </h3>
          </AccordionTitle>

          {/* content 부분 */}
          <AccordionContent active={isAccordionActive}>
            <div className='row'>
              <div className="information2 align-center pb-3">
                <p>
                  * 시리얼번호를 알 수 없는 경우 <span className='emphasis'>서비스 비용이 청구</span> 될 수 있습니다.
                  <br/>
                  * <span className='emphasis'>QR, 업로드, 직접입력</span> 중 편한 방법으로 시리얼번호를 입력해 주세요.
                  <br/>
                  * 시리얼번호를 <span className='emphasis'>모르겠는</span> 경우 아래 <span className='emphasis'>모델검색</span>을 이용해 주시길 바랍니다.
                </p>

              <img src={serialExampleImage} alt="Drax" className="py-1" style={{ cursor:'pointer', width: '90%', height: 'auto', maxWidth: '350px'}}/>

              </div>
            </div>
            <div className='row'>
              <div className='col'>
                <Button fluid onClick={handleQrScanClick}>
                  <Icon name='qrcode'></Icon>
                  QR 촬영
                </Button>
                {qrScanning ? <QrScanner onScanSuccess={handleScanSuccess} onScanError={handleScanError}/> : null}
              </div>
              <div className='col'>
                <Button fluid onClick={handleSerialNumberUploadClick}>
                  <Icon name='camera'></Icon>
                  업로드(시리얼인식)
                </Button>
                <input
                  type='file'
                  ref={fileInputRef}
                  onChange={handleFileChange}
                  style={{ display: 'none' }}
                />
              </div>
            </div>
            <div className='row'>
              <div className='col py-2'>
                <Input
                  className="truncate-input"
                  action={{ content: '조회', onClick: handleSearchClick }}
                  placeholder='시리얼번호'
                  fluid // Makes the input take the full width of its container
                  value={serialSearchTerm}
                  onChange={(e) => setSerialSearchTerm(e.target.value)}
                />
              </div>
            </div>
          </AccordionContent>
        </Accordion>
      </div>
      <div className="card">
        <h3 className="mt-2 mb-4 align-center">모델 검색</h3>
        <div className="p-1 m-1 ">
          <div>
            <div className='row align-items-center'>
              <div className='col' style={{ padding: '0px 1px 0px 8px'}}>
                <Dropdown
                  className="truncate-dropdown" // Use a new class for styling
                  placeholder='카테고리'
                  fluid
                  selection
                  button
                  options={categoryOptions}
                  value={selectedCategory}
                  onChange={(event, data) => {
                    setSelectedCategory(data.value as string);
                    sessionStorage.setItem('selectedCategory', data.value as string);
                  }}
                />
              </div>

              <div className='col' style={{ padding: '0px 8px 0px 1px' }}>
                <Dropdown
                  className="truncate-dropdown" // Apply the same class here
                  placeholder='제품'
                  fluid
                  selection
                  button
                  options={productOptions}
                  value={selectedProduct}
                  onClick={productDropdownOnclickHandler}
                  onChange={(event, data) => {
                    setSelectedProduct(data.value as string);
                    setSelectedProductName(productOptions.find(option => option.value === data.value)?.text || '');
                  }}
                />
              </div>
            </div>
            <div className='row align-items-center'>
              <div className='col' style={{ padding: '4px 8px 0px 8px' , flexBasis:'29%'}}>
                <Input
                  className="truncate-input" // Use a class for the input field
                  icon='search'
                  placeholder='모델명'
                  fluid
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  />
              </div>
            </div>
            <div className='row align-items-center'>
              <div>
                <Divider horizontal className='p-2'>
                  <Icon name="cog" />모델선택
                </Divider>
              <div className="information2 align-center pb-1">
              </div>
              <div className="pb-1">
                <h3 style={{ margin: '5px' }}>선택된 모델</h3>
              </div>

              {/* 전체삭제 버튼 추가 20251118 */}
              {selectedModelsList && selectedModelsList.length > 0 && (
                <div style={{ display: 'flex', alignItems: 'right', gap: '10px', margin: '0 10px', flexDirection: 'row-reverse' }}>
                <Button
                  color='red'
                  size="mini"
                  align='right'
                  compact={true}
                  onClick={() => setAllDeleteOpen(true)}
                >
                  전체 삭제
                </Button>
              </div>
              )}
              <Confirm
                open={allDeleteOpen}
                onCancel={() => setAllDeleteOpen(false)}
                onConfirm={() => {
                  setSelectedModelsList([]);
                  setAllDeleteOpen(false);
                  sessionStorage.removeItem('selectedModel');
                }}
                header='전체 모델 삭제'
                content='정말로 전체 선택된 모델을 삭제하시겠습니까?, (개별 삭제를 원하시면 해당 모델을 클릭하여 삭제를 진행해주세요)'
                confirmButton="전체 삭제"
                cancelButton="취소"
              />

              <div className={`${selectedModelDiv ? 'shake' : ''}`} style={{ margin: '10px' }}>
                {genSelectedModelString()}
              </div>

              <div style={{ margin: '10px' }}>
                {renderModels(models)}
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-2" />
          <div className="align-center col-8">
            <Button color='grey' className="p-3" onClick={handlePrevButtonClick}>이전</Button>
            <Button style={{ backgroundColor: '#F2711C', color: 'white' }} color='orange' className="p-3" onClick={handleNextButtonClick}>다음으로</Button>
          </div>
        <div className="col-2" />
      </div>
      <div className="row">
        <div className="align-center col">
          {genConfirmModal()}
        </div>
      </div>
      <Modal
        open={openModal}
        onClose={() => {
          setOpenModal(false);
          setSelectedDetails(new Set()); // Reset selected items
        }}
        closeIcon
      >
        <Header content='모델 상세 정보' />
        <Modal.Content>
          {currentModel && (
            <>
              <h3>[{currentModel.product_name}]{currentModel.model}</h3>
              <Header as='h5'>시리얼 상세</Header>
              <Table celled unstackable>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell width={1}>
                      <Checkbox
                        onChange={() => {
                          if (selectedDetails.size === currentModel.modelDetail.length) {
                            setSelectedDetails(new Set());
                          } else {
                            setSelectedDetails(new Set(currentModel.modelDetail));
                          }
                        }}
                        checked={selectedDetails.size === currentModel.modelDetail.length}
                      />
                    </Table.HeaderCell>
                    <Table.HeaderCell width={1}>No</Table.HeaderCell>
                    <Table.HeaderCell>시리얼 번호</Table.HeaderCell>
                    <Table.HeaderCell>보증기간</Table.HeaderCell>
                    <Table.HeaderCell>이미지url</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  {currentModel.modelDetail.map((detail, index) => (
                    <Table.Row key={index}>
                      <Table.Cell>
                        <Checkbox
                          onChange={() => {
                            const newSelectedDetails = new Set(selectedDetails);
                            if (newSelectedDetails.has(detail)) {
                              newSelectedDetails.delete(detail);
                            } else {
                              newSelectedDetails.add(detail);
                            }
                            setSelectedDetails(newSelectedDetails);
                          }}
                          checked={selectedDetails.has(detail)}
                        />
                      </Table.Cell>
                      <Table.Cell>{index + 1}</Table.Cell> {/* 1부터 시작하는 인덱스 */}
                      <Table.Cell>
                        {detail.isSerial ? detail.serialNumber : '-'}
                      </Table.Cell>
                      <Table.Cell>
                        {detail.warrantyDetail?.warranty_due_date}
                      </Table.Cell>                      
                      <Table.Cell textAlign='center'>
                        {detail.serialImageUrl && (
                          <a href={detail.serialImageUrl} target="_blank" rel="noopener noreferrer">
                            <Icon name='external alternate' color='blue' />
                          </a>
                        )}
                      </Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            </>
          )}
        </Modal.Content>

        <Modal.Actions>
          <Button negative onClick={handleDeleteDetails}>
            선택 항목 삭제 ({selectedDetails.size})
          </Button>
          <Button onClick={() => setOpenModal(false)}>
            닫기
          </Button>
        </Modal.Actions>
      </Modal>
    </>
    );
}

export default InputMachine;